/* eslint-disable jsx-a11y/no-distracting-elements */
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { fetchAds, STATUSES } from "../../../redux/getReducer/getAdsSlice";
import Cookies from "js-cookie";

const ExNews = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { data: ads = [], status } = useSelector((state) => state.ads);

  const cookiedata = Cookies.get("i18next");

  useEffect(() => {
    if (!ads || ads.length === 0) {
      dispatch(fetchAds());
    }
  }, [dispatch, ads]);

  if (status === STATUSES.LOADING) {
    return <></>;
  }

  if (status === STATUSES.ERROR) {
    return ( 
      <div className="d-flex exnews justify-content-center newsD"> 
        <span className="newsflex" > 
            <p className="news_ticker">
              {t("Something went wrong while loading the news.")}
            </p> 
        </span> 
      </div>
    );
  }

  const isDirection = cookiedata === "en" ? "left" : "right";

  return (
    <>
      <div className="exnews newsD">
        {ads?.length > 0 &&
          ads.slice(-1).map((item, index) => (
            <span className="newsflex" key={item._id || index}>
              <p>{t("Exclusive")}</p>
              <marquee direction={isDirection}>
                <p className="news_ticker">
                  {cookiedata === "en"
                    ? item.DescriptionEn
                    : item.DescriptionAr}
                </p>
              </marquee>
            </span>
          ))}
      </div>
    </>
  );
};

export default ExNews;
